import { CompanyChallengeCategoryDto } from '@src/type/challenge'
import { Topic, TopicOption } from './type'

export function prepareTopic(categoryDtos: CompanyChallengeCategoryDto[]): {
	topics: Topic[]
	topicOptions: TopicOption[]
} {
	categoryDtos.sort((prev, next) => {
		const prevOrder = Number.parseInt(prev.order, 10)
		const nextOrder = Number.parseInt(next.order, 10)

		if (prev.parent_no === null || next.parent_no === null) {
			if (prev.parent_no === null && next.parent_no === null) {
				return prevOrder - nextOrder
			}

			if (prev.parent_no === null && next.parent_no !== null) {
				return -1
			}

			// prev.parent_no !== null && next.parent_no === null
			return 1
		}

		// prev.parent_no !== null && next.parent_no !== null
		if (prev.parent_no !== next.parent_no) {
			return Number.parseInt(prev.parent_no, 10) - Number.parseInt(next.parent_no, 10)
		}

		return prevOrder - nextOrder
	})

	const topicOptions: TopicOption[] = []
	const topics: Topic[] = []

	categoryDtos.forEach((categoryDto) => {
		if (categoryDto.parent_no === null) {
			const parentTopicOption = {
				label: categoryDto.name,
				value: Number.parseInt(categoryDto.no, 10),
			}

			topicOptions.push(parentTopicOption)
			return
		}

		const parentTopicOption = topicOptions.find(
			(topicOption) => topicOption.value === Number.parseInt(categoryDto.parent_no!, 10),
		)

		if (!parentTopicOption) {
			console.log(
				'알 수 없는 오류 상황 발생: 대분류 주제가 생성되기 전에 하분류 주제를 생성하려고 함',
			)
			return
		}

		const childTopicOption: TopicOption = {
			label: categoryDto.name,
			value: Number.parseInt(categoryDto.no, 10),
		}

		if ('children' in parentTopicOption && Array.isArray(parentTopicOption.children)) {
			parentTopicOption.children.push(childTopicOption)
		} else {
			parentTopicOption.children = [childTopicOption]
		}

		topics.push({
			id: Number.parseInt(categoryDto.no, 10),
			parentId: Number.parseInt(categoryDto.parent_no, 10),
			name: categoryDto.name,
			order: Number.parseInt(categoryDto.order, 10),
			sampleProofs: categoryDto.sample_proof || [],
			challengeCategories: categoryDto.challenge_category || [],
			stickers: categoryDto.sticker || [],
		})
	})

	topicOptions.push({
		label: '기타',
		value: 0,
	})

	return {
		topics,
		topicOptions,
	}
}
